// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29Zgs","image":"Header_image__ZSjgA","name":"Header_name__2Rw0Z","info":"Header_info__1RzdV","infoRow":"Header_infoRow__1PvCO"};